// invariant(): a strict assertion that throws InvariantViolation on failure.
// Use only for "this should never happen" cases. For expected errors, use
// Result<T, E>. The bundled message is preserved in production builds —
// keep messages helpful for on-call.

export class InvariantViolation extends Error {
  override readonly name = "InvariantViolation";
}

export function invariant(condition: unknown, message: string): asserts condition {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- intentional: invariant is meant to handle any truthy/falsy.
  if (!condition) {
    throw new InvariantViolation(message);
  }
}
